import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

// RBAC is enforced in-tree by RouteRoleGate (src/lib/route-role-gate.tsx) once
// RoleContext resolves — review-queue → client + admin + supervisor + owner
// (route-permissions.ts SCREEN_ACCESS). Gating cannot live in a beforeLoad
// guard: on cold loads the guard runs before MainAppLayout registers the role,
// which deadlocked and bounced every deep-link to /dashboard. The backend still
// enforces RBAC on every API call.
export const Route = createFileRoute('/review-queue')({
  component: lazyRouteComponent(() => import('./-review-queue.lazy'), 'default'),
});
